module.exports = __webpack_public_path__ + "img/IMG.32b92697.png";